var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBAppStock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2648 0H9.73519C4.35859 0 0 4.35859 0 9.73519V44.2648C0 49.6414 4.35859 54 9.73519 54H44.2648C49.6414 54 54 49.6414 54 44.2648V9.73519C54 4.35859 49.6414 0 44.2648 0Z",
    fill: "#000B1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.459 15.583L28.4224 22.0586C27.0161 20.9853 24.2041 19.8013 20.7627 19.8013C18.7275 19.8013 17.9136 20.4673 17.9136 21.3923C17.9136 22.3176 18.5425 22.6875 21.2437 23.4646C28.3481 25.5366 30.1611 27.979 30.1611 31.7161C30.1611 36.6375 26.0908 39.6716 19.7266 39.6716C15.9155 39.6716 13.0293 38.7466 10.8091 37.4517L10.8457 30.717C13.1401 32.4932 16.5073 33.7883 19.6895 33.7883C21.7246 33.7883 22.6499 33.2332 22.6499 32.1602C22.6499 31.0872 21.6875 30.5691 19.0605 29.866C14.0283 28.46 10.4761 26.7207 10.4761 21.8735C10.4761 17.1741 14.2871 13.918 20.7627 13.918C23.7598 13.918 26.7202 14.4729 28.459 15.583Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2686 20.0603H43.8213V25.2036H40.2686V31.7903C40.2686 33.5662 41.0088 34.2324 42.2666 34.2324C42.6738 34.2324 43.2656 34.1584 43.8213 33.9734L43.8579 39.0796C43.0439 39.3757 42.1558 39.5608 40.4907 39.5608C36.2725 39.5608 33.793 37.5625 33.793 32.8262V25.2036H31.0181V20.0603H33.793V15.2131H40.2686L40.2686 20.0603Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBAppStock);
export default __webpack_public_path__ + "static/media/B_app_Stock.eec49f87db2d39dff4f54c464c0a75ba.svg";
export { ForwardRef as ReactComponent };